import { ROLES } from '../../constants';
import some from 'lodash/some';

/*
 * Checks whether the current user has the required user access permissions to view a certain part of the application
 */
export const isRouteAuthorized = (user, pathname) => {
    const firstSegment = pathname.split('/')[0];

    if (!user) {
        return true;
    }

    const roles = user.functions;

    switch (firstSegment) {
        case '':
        case 'dashboard':
            return some(roles, f => f === ROLES.DASHBOARD_MENU);
        case 'runs':
            return some(roles, f => f === ROLES.RUN_MENU);
        case 'manifests':
            return some(roles, f => f === ROLES.MANIFEST_MENU);
        case 'reports':
            return some(roles, f => f === ROLES.REPORTS_MENU);
        default:
            return false;
    }
};
